import * as go from 'gojs';
import { getImageStorage } from 'unitData/Storage/StorageData';
import { OutputFlowPanel } from '../../Panels/outputFlowPanel';
import { getImageBinding, getIOPort, makeNode } from '../../utils';
import theme from 'theme/theme';
import type { StorageNodeData } from 'gojs/types';

const $ = go.GraphObject.make;

const StorageTemplate = makeNode(
  getImageBinding('storageImg', getImageStorage),
  [
    getIOPort(go.Spot.Bottom, 'output'),
    getIOPort(go.Spot.Top, 'input'),
    $(
      go.Panel,
      'Auto',
      { alignment: new go.Spot(0.5, 1, 0, -12) },
      new go.Binding('visible', '', (data: StorageNodeData) => {
        if (!data.massFlows || typeof data.retainedAmount === 'undefined') {
          return false;
        }
        return data.outputFlow && data.outputFlow?.totalMass >= 0;
      }),
      $(go.Shape, 'RoundedRectangle', {
        strokeWidth: 0,
        fill: theme.palette.info.main,
        alignment: go.Spot.Bottom,
      }),
      OutputFlowPanel(),
    ),
  ],
);

export default StorageTemplate;
